import { render } from "./OrderDetailTab.vue?vue&type=template&id=0d36805a&scoped=true"
import script from "./OrderDetailTab.vue?vue&type=script&lang=js"
export * from "./OrderDetailTab.vue?vue&type=script&lang=js"

import "./OrderDetailTab.vue?vue&type=style&index=0&id=0d36805a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d36805a"]])

export default __exports__